module.exports = __webpack_public_path__ + "img/energy.056dd1ef.svg";